export default function CurrencyIcon() {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4C19 2.34315 15.866 1 12 1C8.13401 1 5 2.34315 5 4M19 4V8C19 9.01946 17.8135 9.92016 16 10.4623C14.8662 10.8012 13.4872 11 12 11C10.5128 11 9.13383 10.8012 8 10.4623C6.18652 9.92016 5 9.01946 5 8V4M19 4C19 5.01946 17.8135 5.92016 16 6.46228C14.8662 6.80122 13.4872 7 12 7C10.5128 7 9.13383 6.80122 8 6.46228C6.18652 5.92016 5 5.01946 5 4M1 8.00012V12.0001C1 13.0196 2.18652 13.9203 4 14.4624C5.13383 14.8013 6.51275 15.0001 8 15.0001C9.48725 15.0001 10.8662 14.8013 12 14.4624C13.8135 13.9203 15 13.0196 15 12.0001V11.0001M1 8.00012C1 6.80338 2.63505 5.7703 5 5.28882M1 8.00012C1 9.01958 2.18652 9.92028 4 10.4624C5.13383 10.8013 6.51275 11.0001 8 11.0001C8.69497 11.0001 9.36629 10.9567 10 10.8759"
        stroke="#D4D4D8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
